import { useCallback, useState } from "react";
import { callCreateCsaCheckoutSession } from "../../../api/pickups";

export function useStartCsaCheckout() {
  const [isStartingCheckout, setIsStartingCheckout] = useState(false);
  const [checkoutError, setCheckoutError] = useState<string | null>(null);

  const startCsaCheckout = useCallback(async () => {
    setIsStartingCheckout(true);
    setCheckoutError(null);
    try {
      const { checkoutUrl } = await callCreateCsaCheckoutSession();
      window.location.assign(checkoutUrl);
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { message?: string } } })?.response?.data
          ?.message ?? "Could not start payment. Please try again.";
      setCheckoutError(msg);
      setIsStartingCheckout(false);
    }
  }, []);

  return { startCsaCheckout, isStartingCheckout, checkoutError };
}
